import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
export function Navbar() {
  return <motion.nav initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.8
  }} className="fixed top-0 left-0 right-0 z-50 bg-cosmic-black bg-opacity-80 backdrop-blur-sm border-b border-gold-primary border-opacity-20" data-id="element-213">
      <div className="container mx-auto px-6 py-4 flex justify-between items-center" data-id="element-214">
        <Link to="/" className="text-2xl md:text-3xl font-serif font-bold text-gold-light tracking-wider hover:text-gold-primary transition-colors" data-id="element-215">
          LOS 12
        </Link>
      </div>
    </motion.nav>;
}